import type { Column } from '@tanstack/react-table';
import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';
import type { FilterLayout } from '../types';

interface ColumnFilterContextData {
  column?: Column<any>;
  layout?: FilterLayout;
}

const ColumnFilterContext = createContext<ColumnFilterContextData>({});

export const ColumnFilterProvider = ({
  column,
  layout,
  children,
}: {
  column: Column<any>;
  layout: FilterLayout;
  children: ReactNode;
}) => (
  <ColumnFilterContext.Provider value={{ column, layout }}>
    {children}
  </ColumnFilterContext.Provider>
);

export const useColumnFilter = () => useContext(ColumnFilterContext);
